import { graphql } from "relay-runtime"

export const advancedCareProviderSearchQuery = graphql`
  query useAdvancedCareProviderSearchQuery($input: CareProviderAdvancedSearchInput!, $language: String!) {
    ch_careProviderAdvancedSearch(input: $input) {
      results {
        id
        streetAddress
        title
        website
        businessName
        firstName
        lastName
        additionalAddress
        city
        officialLanguageIds
        countryCode
        creditorCodeRegister
        distance
        globalLocationNumber
        highlights {
          key
          value
        }
        email
        phoneNumber
        postalCode
        relationBusinessName
        relationFirstName
        relationLastName
        relationTitle
        relationType
        careProviderSpecialtyTranslations(language: $language) {
          id
          name
        }
        careProviderGroupQuickList {
          groupType
        }
        country {
          countryName(language: $language)
        }
        groupName(language: $language)
        isMedgatePartnerNetworkMember
        insuranceCareProviderListIds
        isTakesNewPatients
        network {
          name
        }
        detailedSchedule {
          day
          workingType
          periods {
            start
            end
          }
        }
      }
    }
  }
`
